// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2IOHI","clinicsSelect":"TableHeading_clinicsSelect__2RfJY"};